import { GetServerSideProps } from 'next';
import { allSettled, fork, serialize } from 'effector';

import { casesPage, CasesPage } from '@/page-content/cases';

import { EFFECTOR_STATE_KEY } from '@/shared/lib/effector';
import { getPageContext } from '@/shared/lib/effector/page';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const scope = fork();

  await allSettled(casesPage.open, { scope, params: getPageContext(ctx) });

  return {
    props: {
      [EFFECTOR_STATE_KEY]: serialize(scope),
    },
  };
};

export default CasesPage;
